/**
 * 获取购物车项的稳定唯一键，兼容普通商品、报价项与手工录入项。
 * @param {Object} item 购物车项
 * @returns {string} 稳定唯一键
 */
export const getCartItemKey = (item = {}) => {
  if (item?.cartItemId) {
    return String(item.cartItemId);
  }

  if (item?.isQuoteItem && item?.quoteId) {
    return `quote:${item.quoteId}`;
  }

  if (item?.bomOrderId && item?.product) {
    return `bom:${item.bomOrderId}:product:${item.product}`;
  }

  if (item?.product) {
    return `product:${item.product}`;
  }

  if (item?.partNumber) {
    return `manual:${item.partNumber}`;
  }

  return `cart:${item?.name || "item"}`;
};

/**
 * 标准化购物车项，确保普通商品与报价项结构统一。
 * @param {Object} item 原始购物车项
 * @returns {Object} 标准化后的购物车项
 */
export const normalizeCartItem = (item = {}) => {
  return {
    ...item,
    cartItemId: getCartItemKey(item),
    isQuoteItem: Boolean(item?.isQuoteItem),
    quantity: Number(item?.quantity || 1),
    price: Number(item?.price || 0),
    multipleOrderQuantity: Number(item?.multipleOrderQuantity || 1),
  };
};

/**
 * 获取购物车项可跳转的链接。
 * @param {Object} item 购物车项
 * @returns {string|null} 路由链接；报价项返回 null
 */
export const getCartItemLink = (item = {}) => {
  if (item?.isQuoteItem) {
    return null;
  }

  if (item?.product) {
    return `/products/${item.product}`;
  }

  return null;
};
